import UdeskLocales from 'UdeskLocales';
import React, { FC } from 'react';
import { Tabs } from 'udesk-ui';
import './style.scss';

interface TemplateProps {
    activeTabKey?: string;
    onChange?: (key: string) => void;
}

const Template: FC<TemplateProps> = (props) => {
    const { activeTabKey, onChange: propsOnChange } = props;

    const locales = UdeskLocales['current'];

    const tabs = [
        {
            tab: locales.components.pages.appealSdk.appealSdkIndex.title,
            key: 'QaResultView',
        },
        {
            tab: /* 案例库 */ UdeskLocales['current'].pages.appealCheckingTask.sdk.components
                .viewTabs.index.caseLibrary,
            key: 'CaseLibView',
        },
    ];

    return (
        <Tabs
            activeKey={activeTabKey}
            onChange={propsOnChange}
            className="appeal-checking-task-page-view-tabs"
            size="small"
        >
            {tabs.map((t) => (
                <Tabs.TabPane tab={<div style={{ fontSize: 18 }}>{t.tab}</div>} key={t.key} />
            ))}
        </Tabs>
    );
};

export default Template;
